import { render, staticRenderFns } from "./MuralSales.vue?vue&type=template&id=b4881dd4&scoped=true"
import script from "./MuralSales.vue?vue&type=script&lang=js"
export * from "./MuralSales.vue?vue&type=script&lang=js"
import style0 from "./MuralSales.vue?vue&type=style&index=0&id=b4881dd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4881dd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4881dd4')) {
      api.createRecord('b4881dd4', component.options)
    } else {
      api.reload('b4881dd4', component.options)
    }
    module.hot.accept("./MuralSales.vue?vue&type=template&id=b4881dd4&scoped=true", function () {
      api.rerender('b4881dd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/mural/MuralSales.vue"
export default component.exports